import { cubicBezier, motion } from 'motion/react';
import { Menu, MenuTrigger, Popover } from 'react-aria-components';
import { ButtonProps } from '../../atoms/button/button';
import {
  ProfileMenuItem,
  ProfileMenuItemProps,
} from '../../atoms/profileMenuItem/profileMenuItem';
import { Button } from '../../ui';

type Props = {
  menuItems: Array<ProfileMenuItemProps>;
} & ButtonProps;

export function ButtonMenu(props: Props) {
  const { menuItems, ...rest } = props;

  return (
    <MenuTrigger>
      <Button {...rest} />

      <Popover>
        <motion.div
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            ease: cubicBezier(0.25, 1, 0.5, 1),
            duration: 0.3,
          }}
        >
          <Menu className="bg-grayscale0 rounded-6 space-y-8 py-8 shadow-1 border-grayscale100">
            {menuItems.map((menuItemProps, index) => (
              <ProfileMenuItem
                key={`profile-menu-item-${index}`}
                {...menuItemProps}
              />
            ))}
          </Menu>
        </motion.div>
      </Popover>
    </MenuTrigger>
  );
}
